export default {
  state: {
    filters: [],
    params: [],
  },

  mutations: {
    setFilters(state, payload) {
      state.filters = payload;
    },
    setParams(state, payload) {
      state.params = payload;
    },
  },

  actions: {
    setReportFilters({ commit }, payload) {
      commit("setFilters", payload);
    },
    setReportParams({ commit }, payload) {
      commit("setParams", payload);
    },
  },

  getters: {
    reportFilters(state) {
      return state.filters;
    },
    reportParams(state) {
      return state.params;
    },
    getPdfBlacklistReport() {
      return [
        "Orders Itemized",
        "Fundraiser",
        "Coupon Summary",
        "Shipping Costs",
        "Consolidated Supplier PO",
        "Store Product List",
        "Products Ordered",
        // 'Shopper Summary'
      ];
    },
    getCsvBlacklistReport() {
      return ["Supplier PO’s by Decoration/Customization"];
    },

    getCompletedReport() {
      return [
        "Bin Report",
        "Batch Summary",
        "Decorator/Customizer PO’s",
        "Receiving Report",
        "Fulfillment PO",
        "Pick, Pack and Bag",
        "Label",
        // 'OrderWrite PO',
        "Supplier Summary",
        "Supplier PO’s by Decoration/Customization",
      ];
    },

    getReportGroups() {
      return [
        {
          groupName: "",
          groupDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do elusmod tempor incididunt ut labore",
          groupReports: [
            {
              reportName: "Orders Itemized",
              reportDescription:
                "A detailed view of each shopper's order and store sales totals",
              reportIcon: "ow_logo.png",
              requireBatch: false,
            },
          ],
          requireBatch: false,
        },
        {
          groupName: "",
          groupDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do elusmod tempor incididunt ut labore",
          groupReports: [
            {
              reportName: "Store Product List",
              reportDescription:
                "Lists all the products and their details such as Sale Price, Color, Size, Logo Position 1 ... and so forth.",
              reportIcon: "ow_logo.png",
              displayForClientAdmin: false,
              hideWhenBatchSelected: true,
              isStoreReport: true,
            },
            {
              reportName: "Products Ordered",
              reportDescription:
                "See how many of each product your store has sold",
              reportIcon: "ow_logo.png",
              displayForClientAdmin: true,
              hideWhenBatchSelected: true,
              isStoreReport: true,
            },
            // {
            //   reportName: 'Shopper Summary',
            //   reportDescription:
            //                     'A summary view of each shopper’s order, including the total number of items purchased and how much money was spent',
            //   reportIcon: 'ow_logo.png'
            // }
          ],
          displayForClientAdmin: true,
        },
        {
          groupName: "Purchase Orders",
          groupDescription:
            "To view purchase orders and final store reports, please complete your store or create a new batch in the orders tab. Please make any necessary changes to orders and products prior to completing your store so your reports will be accurate. Your final reports will include any changes you've made.",
          groupReports: [
            {
              reportName: "Supplier PO’s by Decoration/Customization",
              reportDescription:
                "Shows the products you need to order from each supplier, grouped by decoration combination. Use to purchase the items shoppers ordered in your store from your suppliers.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Decorator/Customizer PO’s",
              reportDescription:
                "Lists the decorations, the number of items ordered, and costs for each imprint by the decorator. It totals the costs per decorator, so you can quickly order their services.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Fulfillment PO",
              reportDescription:
                "Lists the number of items ordered, the pick, pack, and bag costs, and the total fulfillment cost for your store.",
              reportIcon: "ow_logo.png",
            },
          ],
          displayForClientAdmin: false,
          requireOrders: true,
          requireBatch: true,
        },
        {
          groupName: "Sales and Revenue Reports",
          groupDescription:
            "Summary data you to help you easily transfer and record sales in any oder-entry system.",
          groupReports: [
            {
              reportName: "Batch Summary",
              reportDescription:
                "Shows the amount of money collected from customers, and any money to collect via invoices. Summarizes the total costs & sales by vendor and any fees associated with shipping or payment features.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Supplier Summary",
              reportDescription:
                "Lists the number of items ordered, the total costs of goods, and total sales for each supplier. This report shows each supplier’s exact contribution to store sales.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Fundraiser Summary",
              reportDescription:
                "Quickly Calculates and displays how much money you raised in your store.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Shipping Costs",
              reportDescription:
                "Details the amount collected for shipping on each order. If the store collects taxes and fundraising dollars from shoppers, those details will be listed too.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Credit Card",
              reportDescription:
                "Details the credit card charge for each order, including base costs, extra costs, and taxes if applicable. ",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Sales Tax",
              reportDescription:
                "Lists the tax jurisdiction, tax percentage, and sales tax collected for each order and calculates the total sales tax collected in your store.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Payroll Deduction",
              reportDescription:
                "Applies to stores with shopper payments set to “Offer Shopper Allowance” & “Invoice/ Payroll deductions.” Shows who went over their allowance and by how much so your client can efficiently perform payroll deductions.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Fundraiser",
              reportDescription:
                "View customer orders and overall Fundraiser Amount ordered. Details how much money you raised for your client’s organization and how much money you made in actual product sales.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Coupon Summary",
              reportDescription:
                "Shows the total coupon amount used during your sale to invoice your main point of contact/ client. It lists all store orders and discount details if coupons were redeemed.",
              reportIcon: "ow_logo.png",
            },
          ],
          displayForClientAdmin: false,
          requireBatch: true,
          requireOrders: true,
        },

        {
          groupName: "Fulfillment",
          groupDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do elusmod tempor incididunt ut labore",
          groupReports: [
            {
              reportName: "Drop Shipment",
              reportDescription:
                "Tells you the total number of orders shipping to each location in your store. Use this report to verify totals are correct before sending drop-shipments.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Receiving Report",
              reportDescription:
                "Shows the supplier, decoration, and total quantity for each product ordered in your store. Use this list to confirm that all your store products have arrived before fulfilling individual orders.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Bin Report",
              reportDescription:
                "Lists a bin number and quantity for each item ordered. Separate items into bins when they’re decorated to pull and pack individual orders.",
              reportIcon: "ow_logo.png",
            },
            {
              reportName: "Pick, Pack and Bag",
              reportDescription:
                "Export this report to create pick tickets and other order labels. List all the information collected at checkout from individuals, which bins products they ordered are in, and how many you need to “pick” from that Bin to pack their order.",
              reportIcon: "ow_logo.png",
            },
          ],
          displayForClientAdmin: false,
          requireBatch: true,
          requireOrders: true,
        },
        {
          groupName: "All Reports",
          groupDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do elusmod tempor incididunt ut labore",
          groupReports: [
            {
              reportName: "All Reports",
              reportDescription: "View all reports available to your store",
              reportIcon: "ow_logo.png",
            },
          ],
          requireBatch: true,
          displayForClientAdmin: false,
        },
      ];
    },
  },
};
